
import React from 'react'
import uuid from 'react-uuid'

import { Upload } from 'antd'

import { buildStorageKey, buildFormData, doUpload } from './utils'

import api from 'lib/api'

// import styles from './styles.module.scss'

const TransferUploadPanel = ({ children, isDisabled, accepts, transferId, id, storageKey, meta, listType, filename, onRefresh }) => {

  const { Dragger } = Upload

  const props = {
    disabled: isDisabled || false,
    accepts: accepts || '',
    name: 'file',
    multiple: true,
    uid: id || uuid(),
    listType: listType || 'picture',
    fileList: [],
    customRequest: async ({ onSuccess, onError, file }) => {
      try {    
        const fileStorageKey = buildStorageKey(storageKey, file, filename)
        const options = {
          key: fileStorageKey,
          meta
        }
        const data = await api.inventory.createPublicSignedUrl(transferId, options)
        const { params, formData } = buildFormData(file, data, fileStorageKey)
        if (formData) {
          const options = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          const response = await doUpload(data, formData, options, params)
          if (response) {
            onSuccess(null, file)
            onRefresh(response)
          } else {
            throw new Error('Could not upload file')
          }
        } else {
          throw new Error('Could not generate form data')
        }
      } catch(e) {
        console.error(e)
        onError(e.message, e, file)
      }
    }
  }

  return (
    <div>
      <Dragger {...props}>
        {children}
      </Dragger>
    </div>
  )
}

export default TransferUploadPanel